/**
 * Sprint 6.8.2 — Types d'opérations RÉELS extraits des CSV Caisse KOST
 * (Trip Sun février 2024 + Formation B2C février 2024).
 *
 * Filtré dynamiquement par (sens × activité bénéficiaire) dans la modal
 * "Nouvelle opération de caisse".
 */

export interface OperationTypeOption {
  code: string;
  label: string;
  icon: string;
}

export const TRIP_SUN_ENTREES: OperationTypeOption[] = [
  { code: 'evaluation_preliminaire', label: 'Évaluation préliminaire', icon: '📋' },
  { code: 'accompagnement_avec_suivi', label: 'Accompagnement avec suivi', icon: '🎯' },
  { code: 'accompagnement_sans_suivi', label: 'Accompagnement sans suivi', icon: '🎯' },
  { code: 'visa_touristique', label: 'Visa touristique', icon: '✈️' },
  { code: 'traitement_dossier', label: 'Traitement dossier', icon: '📁' },
  {
    code: 'frais_gouvernement_canada',
    label: 'Frais Gouvernement Canada (pass-through)',
    icon: '🇨🇦',
  },
  { code: 'renouvellement_contrat', label: 'Renouvellement contrat', icon: '🔄' },
  { code: 'acompte_client', label: 'Acompte client', icon: '💰' },
  { code: 'solde_client', label: 'Solde client', icon: '💰' },
  { code: 'retour_client', label: 'Retour / Remboursement client', icon: '↩️' },
  { code: 'autre_entree_trip_sun', label: 'Autre entrée Trip Sun', icon: '➕' },
];

export const TRIP_SUN_SORTIES: OperationTypeOption[] = [
  { code: 'prime_teleoperatrice', label: 'Prime téléopératrice', icon: '👩‍💼' },
  { code: 'boost_facebook_immigration', label: 'BOOST Facebook Ads (immigration)', icon: '📣' },
  { code: 'cnas', label: 'CNAS (charges sociales)', icon: '🏛️' },
  { code: 'g50_taxes', label: 'G50 / Taxes (TAP, IRG, IBS, TVA)', icon: '📊' },
  { code: 'salaire_fixe', label: 'Salaire fixe employé', icon: '💼' },
  { code: 'location_siege', label: 'Location siège (loyer)', icon: '🏢' },
  { code: 'pdg', label: 'PDG / Direction', icon: '👨‍💼' },
  { code: 'notaire', label: 'Notaire', icon: '📜' },
  { code: 'achat_fournitures', label: 'Achat fournitures', icon: '🛒' },
  { code: 'carburant', label: 'Carburant', icon: '⛽' },
  { code: 'frais_bancaires', label: 'Frais bancaires', icon: '🏦' },
  { code: 'cahier_charge', label: 'Cahier de charge', icon: '📚' },
  { code: 'avance_employe', label: 'Avance employé', icon: '💸' },
  { code: 'avance_inter_activites', label: 'Avance vers autre activité', icon: '🔄' },
  { code: 'imprevu_autre_sortie', label: 'Imprévu / Autre sortie', icon: '⚠️' },
];

export const B2C_ENTREES: OperationTypeOption[] = [
  { code: 'pizzalio', label: 'Formation Pizzalio', icon: '🍕' },
  { code: 'plomberie_ch_central', label: 'Plomberie chauffage central', icon: '🔧' },
  { code: 'coiffure', label: 'Coiffure / Coiffeur', icon: '💇' },
  { code: 'cake_design', label: 'Cake Design', icon: '🎂' },
  { code: 'reservation_acompte_b2c', label: 'Réservation / Acompte B2C', icon: '💰' },
  { code: 'suite_paiement_b2c', label: 'Suite de paiement B2C', icon: '💰' },
  { code: 'recette_reservee_b2c', label: 'Recette réservée B2C', icon: '🔒' },
  { code: 'autre_formation_b2c', label: 'Autre formation B2C', icon: '➕' },
];

export const B2C_SORTIES: OperationTypeOption[] = [
  { code: 'honoraires_formateur_b2c', label: 'Honoraires formateur B2C', icon: '👨‍🏫' },
  { code: 'boost_facebook_formation', label: 'BOOST Facebook Ads (formation)', icon: '📣' },
  { code: 'salaire_b2c', label: 'Salaire fixe employé B2C', icon: '💼' },
  { code: 'achat_materiel_formation', label: 'Achat matériel formation', icon: '🛒' },
  { code: 'pdg_b2c', label: 'PDG / Direction', icon: '👨‍💼' },
  { code: 'location_b2c', label: 'Location étages 3+4', icon: '🏢' },
  { code: 'dejeuner_staff', label: 'Déjeuner staff', icon: '🍽️' },
  { code: 'assurance_b2c', label: 'Assurance', icon: '🛡️' },
  { code: 'acompte_b2c', label: 'Acompte fournisseur B2C', icon: '💰' },
  { code: 'avance_b2c', label: 'Avance employé B2C', icon: '💸' },
  { code: 'facture_g50_b2c', label: 'Facture G50', icon: '📊' },
  { code: 'imprevu_b2c', label: 'Imprévu B2C', icon: '⚠️' },
];

export const B2B_ENTREES: OperationTypeOption[] = [
  { code: 'facture_entreprise_b2b', label: 'Facture entreprise B2B', icon: '🧾' },
  { code: 'acompte_entreprise', label: 'Acompte entreprise', icon: '💰' },
  { code: 'solde_entreprise', label: 'Solde entreprise', icon: '💰' },
  { code: 'session_intra', label: 'Session intra-entreprise', icon: '🏢' },
  { code: 'session_inter', label: 'Session inter-entreprises', icon: '🏛️' },
  { code: 'cbta_iata', label: 'Formation CBTA IATA', icon: '✈️' },
  { code: 'autre_b2b', label: 'Autre entrée B2B', icon: '➕' },
];

export const B2B_SORTIES: OperationTypeOption[] = [
  { code: 'honoraires_formateur_b2b', label: 'Honoraires formateur B2B', icon: '👨‍🏫' },
  { code: 'hotel_lieu_b2b', label: 'Hôtel / Lieu (Bay Diab, Mercure...)', icon: '🏨' },
  { code: 'traiteur_b2b', label: 'Traiteur (Hibiscus, Malyom...)', icon: '🍽️' },
  { code: 'transport_formateur', label: 'Transport / Déplacement formateur', icon: '🚗' },
  { code: 'supports_impressions_b2b', label: 'Supports / Impressions', icon: '📄' },
  { code: 'commission_commercial', label: 'Commission commercial', icon: '💼' },
  { code: 'marketing_digital_b2b', label: 'Marketing digital B2B', icon: '📣' },
  { code: 'salaire_b2b', label: 'Salaire fixe B2B', icon: '💼' },
  { code: 'location_b2b', label: 'Location étage 2', icon: '🏢' },
  { code: 'cnas_b2b', label: 'CNAS B2B', icon: '🏛️' },
  { code: 'taxes_b2b', label: 'Taxes B2B (G50)', icon: '📊' },
  { code: 'achat_b2b', label: 'Achat B2B', icon: '🛒' },
  { code: 'avance_b2b', label: 'Avance employé B2B', icon: '💸' },
  { code: 'imprevu_b2b', label: 'Imprévu B2B', icon: '⚠️' },
];

export const GENERIC_ENTREES: OperationTypeOption[] = [
  { code: 'encaissement_client', label: 'Encaissement client', icon: '💰' },
  { code: 'acompte_generique', label: 'Acompte', icon: '💰' },
  { code: 'remboursement_recu', label: 'Remboursement reçu', icon: '↩️' },
  { code: 'avance_recue', label: "Avance reçue d'une activité", icon: '🔄' },
  { code: 'autre_entree', label: 'Autre entrée', icon: '➕' },
];

export const GENERIC_SORTIES: OperationTypeOption[] = [
  { code: 'salaire', label: 'Salaire', icon: '💼' },
  { code: 'loyer', label: 'Loyer / Location', icon: '🏢' },
  { code: 'taxe', label: 'Taxe / Impôt', icon: '📊' },
  { code: 'utilities', label: 'Utilities (eau / électricité)', icon: '⚡' },
  { code: 'fournitures', label: 'Fournitures', icon: '🛒' },
  { code: 'transport', label: 'Transport', icon: '🚗' },
  { code: 'commission', label: 'Commission', icon: '💼' },
  { code: 'autre_sortie', label: 'Autre sortie', icon: '⚠️' },
];

/**
 * Retourne la liste filtrée selon (sens × code activité).
 * Le code activité doit matcher l'`activites.code` (ex. 'trip-sun', 'kost-academy-b2b', 'kost-academy-b2c').
 */
export function getOperationTypes(
  sens: 'entree' | 'sortie' | 'transfert' | null,
  activiteCode: string | null,
): OperationTypeOption[] {
  if (!sens || sens === 'transfert') return [];
  const code = (activiteCode ?? '').toLowerCase();

  const isB2B = /b2b|kost-academy-b2b|formation-b2b/.test(code);
  const isB2C = /b2c|kost-academy-b2c|formation-b2c/.test(code);
  const isTripSun = /trip[\s-]?sun|immigration/.test(code);

  if (sens === 'entree') {
    if (isTripSun) return TRIP_SUN_ENTREES;
    if (isB2C) return B2C_ENTREES;
    if (isB2B) return B2B_ENTREES;
    return GENERIC_ENTREES;
  }
  if (isTripSun) return TRIP_SUN_SORTIES;
  if (isB2C) return B2C_SORTIES;
  if (isB2B) return B2B_SORTIES;
  return GENERIC_SORTIES;
}

/**
 * Mapping vers les valeurs de l'enum `OperationCategorie` (DB) pour stocker
 * une catégorie compatible avec le schéma existant. Pour les codes nouveaux,
 * fallback sur 'autre'.
 */
export function mapTypeCodeToCategorie(code: string): string {
  const m: Record<string, string> = {
    salaire: 'salaire',
    salaire_fixe: 'salaire',
    salaire_b2b: 'salaire',
    salaire_b2c: 'salaire',
    loyer: 'loyer',
    location_siege: 'loyer',
    location_b2b: 'loyer',
    location_b2c: 'loyer',
    cnas: 'charge_sociale',
    cnas_b2b: 'charge_sociale',
    g50_taxes: 'taxe',
    facture_g50_b2c: 'taxe',
    taxes_b2b: 'taxe',
    taxe: 'taxe',
    transport: 'transport',
    transport_formateur: 'transport',
    carburant: 'transport',
    achat_fournitures: 'fournitures',
    achat_materiel_formation: 'fournitures',
    achat_b2b: 'fournitures',
    fournitures: 'fournitures',
    commission: 'commission',
    commission_commercial: 'commission',
    avance_employe: 'avance_personnel',
    avance_b2b: 'avance_personnel',
    avance_b2c: 'avance_personnel',
    avance_inter_activites: 'transfert_interne',
    honoraires_formateur_b2b: 'sous_traitance',
    honoraires_formateur_b2c: 'sous_traitance',
    hotel_lieu_b2b: 'sous_traitance',
    traiteur_b2b: 'sous_traitance',
    encaissement_client: 'vente_service',
    acompte_client: 'vente_service',
    solde_client: 'vente_service',
    acompte_entreprise: 'vente_service',
    solde_entreprise: 'vente_service',
    facture_entreprise_b2b: 'vente_service',
    session_intra: 'vente_service',
    session_inter: 'vente_service',
    cbta_iata: 'vente_service',
    pizzalio: 'vente_service',
    plomberie_ch_central: 'vente_service',
    coiffure: 'vente_service',
    cake_design: 'vente_service',
    reservation_acompte_b2c: 'vente_service',
    suite_paiement_b2c: 'vente_service',
    visa_touristique: 'vente_service',
    accompagnement_avec_suivi: 'vente_service',
    accompagnement_sans_suivi: 'vente_service',
    evaluation_preliminaire: 'vente_service',
    traitement_dossier: 'vente_service',
    frais_gouvernement_canada: 'vente_service',
    renouvellement_contrat: 'vente_service',
    retour_client: 'remboursement',
    remboursement_recu: 'remboursement',
  };
  return m[code] ?? 'autre';
}
